import { render, staticRenderFns } from "./MapExtraDrop.vue?vue&type=template&id=38d8c816&scoped=true&"
import script from "./MapExtraDrop.vue?vue&type=script&lang=js&"
export * from "./MapExtraDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d8c816",
  null
  
)

export default component.exports